<div class="fw-tags">
    <div class="text-muted" *ngIf="tags.length == 0">Keine Tags gefunden - diese können direkt bei Unternehmen, {{ 'LOCATION.LOCATIONS' | translate }}, Dokumenten und Aufgaben angelegt werden.</div>

    <span class="badge fw-tag fw-tag-viewer mb-1" [ngClass]="{selected: selected == tag}" *ngFor="let tag of tags" (click)="select(tag)">
        {{ tag.name }} ({{ tag.count }})
    </span>
</div>
